import { useState } from 'react'
import { Copy, RefreshCw } from 'lucide-react'
import Card from '../components/Card'
import Button from '../components/Button'

const loremIpsum = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'

export default function TextGenerator() {
  const [textType, setTextType] = useState('lorem')
  const [paragraphs, setParagraphs] = useState(3)
  const [words, setWords] = useState(50)
  const [generatedText, setGeneratedText] = useState('')

  const generateLorem = (numParagraphs) => {
    const sentences = [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
      'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.',
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia.',
      'Nisi ut aliquip ex ea commodo consequat.',
      'Duis aute irure dolor in reprehenderit in voluptate.',
      'Velit esse cillum dolore eu fugiat nulla pariatur.',
    ]

    let result = []
    for (let i = 0; i < numParagraphs; i++) {
      const numSentences = Math.floor(Math.random() * 3) + 2
      const paragraph = []
      for (let j = 0; j < numSentences; j++) {
        paragraph.push(sentences[Math.floor(Math.random() * sentences.length)])
      }
      result.push(paragraph.join(' '))
    }
    return result.join('\n\n')
  }

  const generateWords = (numWords) => {
    const words = loremIpsum.split(' ')
    let result = []
    for (let i = 0; i < numWords; i++) {
      result.push(words[i % words.length])
    }
    return result.join(' ')
  }

  const handleGenerate = () => {
    if (textType === 'lorem') {
      setGeneratedText(generateLorem(paragraphs))
    } else {
      setGeneratedText(generateWords(words))
    }
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(generatedText)
    alert('Copied to clipboard!')
  }

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="mb-6">
            <label className="label">Text Type:</label>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="text-type"
                  value="lorem"
                  checked={textType === 'lorem'}
                  onChange={(e) => setTextType(e.target.value)}
                  className="mr-2"
                />
                <span>Lorem Ipsum (Paragraphs)</span>
              </label>
              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="text-type"
                  value="words"
                  checked={textType === 'words'}
                  onChange={(e) => setTextType(e.target.value)}
                  className="mr-2"
                />
                <span>Random Words</span>
              </label>
            </div>

            {textType === 'lorem' ? (
              <div>
                <label className="label">Number of Paragraphs:</label>
                <input
                  type="number"
                  value={paragraphs}
                  onChange={(e) => setParagraphs(Number(e.target.value))}
                  min="1"
                  max="20"
                  className="input w-full"
                />
              </div>
            ) : (
              <div>
                <label className="label">Number of Words:</label>
                <input
                  type="number"
                  value={words}
                  onChange={(e) => setWords(Number(e.target.value))}
                  min="1"
                  max="1000"
                  className="input w-full"
                />
              </div>
            )}
          </div>

          <div className="mb-6">
            <label className="label">Generated Text:</label>
            <textarea
              value={generatedText}
              readOnly
              className="input h-40"
              placeholder="Generated text will appear here..."
            />
          </div>

          <div className="flex gap-4">
            <Button onClick={handleGenerate} variant="primary">
              <RefreshCw className="w-4 h-4 mr-2" />
              Generate
            </Button>
            <Button onClick={handleCopy} variant="secondary" disabled={!generatedText}>
              <Copy className="w-4 h-4 mr-2" />
              Copy
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

